<template>
  <div class="ma-0 achievement-card">
    <v-card
      elevation="0"
      color="transparent"
      @click="navigateToCourseCertificatePage(data._id)"
    >
      <!--      <v-img contain src="https://iili.io/rr61Qs.md.png" />-->

      <div v-html="trainingCertificateHtmlTemplate"></div>

      <v-card-title class="pb-3 ps-0 pt-2">
        <p
          class="text-start body-1 textLight--text ma-0 text-ellipse-2"
          style="opacity: 0.8"
        >
          {{ getLocalisedValue(data.trainingTitle) }}
        </p>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import { getTrainingCertificateHtmlTemplate } from "@/app/course-module/helpers/certificatePreviewHelper";

export default {
  props: {
    data: Object,
    subscriberInfo: Object,
  },
  data() {
    return {
      trainingCertificateHtmlTemplate: "",
    };
  },
  methods: {
    getPreviewTrainingCertificateHeight() {
      const aspectRatio = 1.41;
      let cardWidth = 150;

      const cardElements = document.getElementsByClassName("achievement-card");

      if (cardElements?.length) {
        cardWidth = cardElements[0].clientWidth;
      }

      return cardWidth / aspectRatio;
    },
    getCertificateHtmlTemplate() {
      return getTrainingCertificateHtmlTemplate({
        trainingCertificate: this.data,
        subscriberInfo: this.subscriberInfo,
        height: this.getPreviewTrainingCertificateHeight(),
      });
    },
    navigateToCourseCertificatePage(id) {
      this.$router.push({
        name:
          this.$route.name !== "PublicProfile"
            ? "CourseCertificate"
            : "PublicCourseCertificate",
        params: { id },
      });
    },
  },
  watch: {
    "$vuetify.breakpoint.width": {
      immediate: true,
      handler() {
        setTimeout(() => {
          this.trainingCertificateHtmlTemplate =
            this.getCertificateHtmlTemplate();
        }, 100);
      },
    },
  },
};
</script>
